import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./Styles/index.css";

import * as Sentry from "@sentry/react";

Sentry.init({
  environment: import.meta.env.VITE_SENTRY_ENV ?? "",
  dsn: "https://408ef7fc4113eb62879f2a8d5cb6008e@o4511377710776320.ingest.us.sentry.io/4511390012145664",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
